import { OrganizationId } from 'api/organizations/organizations.types';
import { fetchDeleteAsync, get, post, put } from '../../utils/fetch';
import * as Types from './courses.types';
import { getCurrentOrganizationId } from 'context/User';
import { AssignedCourse } from './courses.types';
import { OptionsGenerator } from 'ui/Select/Select.types';
import { StudentDetail } from 'api/students/students.types';
import {
    PowerTableGetter,
    PowerTableGetterWithId
} from 'ui/PowerTable/PowerTable.types';
import { MoodleCircle } from 'ui/Styled/Styled';

export const createCourse = (props: Types.CreateCourseFormData) =>
    post('Course/CreateCourse', props);

export const getCourses: PowerTableGetter<
    Types.CourseInfo,
    Types.CoursesResponse
> = ({ search }) =>
    get(`Course/GetCourses`, {
        search
    });

export const getCoursesOptions: OptionsGenerator<typeof getCourses, number> = (
    search,
    ...args
) =>
    getCourses({ search }, ...args).then(({ items }) => {
        return items.map((item) => {
            const label =
                item.title ??
                (item.id ? `ID: ${item.id}` : 'Неопознанный курс');

            return {
                label,
                displayLabel: (
                    <>
                        {!!item.moodleId && (
                            <MoodleCircle title="Этот курс интегрирован с Moodle" />
                        )}
                        {label}
                    </>
                ),
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                value: item.id!
            };
        });
    });

export const getCourseById = (courseId: number) =>
    get<Types.CourseInfo>(`Course/${courseId}`);

export const editCourse = (props: Types.CreateCourseFormData) =>
    put<Types.CreateCourseFormData>('Course/UpdateCourse', props);

export const assignCourse = (props: Types.AssignCourseFormData) =>
    post('AssignCourse/AddAssignCourse', props);

export const getCourseDateEndLearning = (courseId: number, startDate: string) =>
    get('AssignCourse/GetDateEndLearning', { courseId, startDate });

export const getAssignedCourses: PowerTableGetter<AssignedCourse> = (
    { search },
    organizationId: OrganizationId = getCurrentOrganizationId()
) => get(`AssignCourse/GetOrganizationAssigns/${organizationId}`, { search });

export const getCourseAssignment = (id: number) =>
    get<AssignedCourse>(`AssignCourse/${id}`);

export const getCourseStudents = (id: number, search?: string) =>
    get<StudentDetail[]>(`AssignCourse/GetStudentsByCourse/${id}`, { search });

export const getCourseAssignments: PowerTableGetterWithId<AssignedCourse> = (
    courseId,
    { search }
) =>
    get<AssignedCourse[]>(`AssignCourse/GetCourseAssigns/${courseId}`, {
        search
    });

export const deleteCourseAssignments = (ids: number[]) =>
    fetchDeleteAsync('AssignCourse/RemoveAssign', ids);

export const deleteCourses = (ids: number[]) =>
    fetchDeleteAsync('Course/RemoveCourses', ids);

export const changeAssignmentRecipiencyDocumentsType = (
    assignId: number,
    data: Types.RecipiencyDocumentsData
) =>
    post(`AssignCourse/CreateRecipiencyDocuments`, {
        ...data,
        assignId
    });
